import { render } from "./module-list.vue?vue&type=template&id=0a6a8c8c"
import script from "./module-list.vue?vue&type=script&lang=js"
export * from "./module-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__